const ButtonPermission = {
  ORDER_ORDERONLINE: 'order-orderOnline', // 订单管理-在线下单
  ORDER_ORDEREXPORT: 'order-orderExport', // 订单管理-订单导出
  ORDER_BATCHCANCEL: 'order-batchCancel', // 订单管理-批量取消
  ORDER_BATCHDELETE: 'order-batchDelete', // 订单管理-批量删除
  ORDER_GROUP: 'order-group', // 订单管理-查看同组
  ORDER_PLACEORDER: 'order-placeOrder', // 下单-提交订单
  ORG_ADDPROJECT: 'org-addProject', // 组织及项目-新建项目
  ORG_EDIT: 'org-edit', // 组织及项目-修改
  ORG_ENABLE: 'org-enable', // 组织及项目-启用/禁用
  ACCOUNT_ADDACCOUNT: 'account-addAccount', // 账号管理-新建账号
  ACCOUNT_EDIT: 'account-edit', // 账号管理-修改
  ACCOUNT_DELETE: 'account-delete', // 账号管理-删除
  ACCOUNT_RESETPASSWORD: 'account-resetPassword', // 账号管理-重置密码
  WAREHOUSE_BATCH_CANCEL: 'account-resetPassword', // 仓配订单-批量取消
  WAREHOUSE_EDIT: 'account-resetPassword', // 仓配订单-编辑
  WAREHOUSE_CANCEL: 'account-resetPassword', // 仓配订单-取消
  SITEMANAGEMENT_STATUS:'/siteManagement-status', // 站点管理-停用启用
  SITEMANAGEMENT_ADD:'/siteManagement-add', // 站点管理-新增
  SITEMANAGEMENT_EDIT:'/siteManagement-edit' ,// 站点管理-编辑
  SITEMANAGEMENT_DELETE:'/siteManagement-delete',// 站点管理-删除
  ORDER_AGAIN:'order-again',// 订单管理-再来一单
  WAREHOUSEORDER_AGAIN:'warehouseOrder-again',// 仓配订单-再来一单
}

export default ButtonPermission;